import type { FC, SVGProps } from 'react';

/**
 * Nothing in this folder is a microphone — the closest are the
 * audioPlayer/volume* set, which are speakers. Filled, to sit in family with
 * pause.tsx, telephone-x.tsx and arrow-left-right.tsx rather than the stroked
 * outliers.
 */
const MicIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z" />
    <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5" />
  </svg>
);

export default MicIcon;
